import {Component, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BlogDetails} from "../../blog/interface/blog-details";
import {ContentPreview} from "../../blog/interface/content-preview";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {SeoService} from "../../seo/seo.service";
import {AddStructuredDataService} from "../../add-structured-data.service";
import {BrowserAPIService, TwitterCardType} from "@bloomscorp/ngbase";
import {SeoData} from "../../seo/interface/seo-data";
import {ContentSectionList} from "../../blog/interface/content-section-list";
import {LoaderModule} from "../../loader/loader.module";
import {StoryTransmissionService} from "../../raintree/transmission/story-transmission.service";
import {StoryDetailsV2} from "../interface/story-details";
import {StoryDetailsTocComponent} from "../story-details-toc/story-details-toc.component";
import {StoryDetailsContentComponent} from "../story-details-content/story-details-content.component";
import {StoryDetailsAboutComponent} from "../story-details-about/story-details-about.component";
import {StoryProductFilterComponent} from "../story-product-filter/story-product-filter.component";

@Component({
  selector: 'fb-story-details',
  standalone: true,
	imports: [CommonModule, LoaderModule, StoryDetailsTocComponent, StoryDetailsContentComponent, StoryDetailsAboutComponent, StoryProductFilterComponent],
  templateUrl: './story-details.component.html',
  styleUrls: ['./story-details.component.scss']
})
export class StoryDetailsComponent implements OnInit, OnDestroy {

	public sidebar: boolean = true;
	public dropdown: boolean = false;
	public storyDetails: StoryDetailsV2 = {} as StoryDetailsV2;
	public storyRecommended: ContentPreview[] = [];
	public paramsSubscription: Subscription = {} as Subscription;
	public isLoading: boolean = true;
	public showFaqCollapsed: boolean = false;
	public storyId: number = 0;

	constructor(
		private _activatedRoute: ActivatedRoute,
		private _storyAPI: StoryTransmissionService,
		private _seo: SeoService,
		private _router: Router,
		private _addStructuredData: AddStructuredDataService,
		private _browser: BrowserAPIService
	) {
	}



	private _getStoryRecommendedList(id: string): void {
		this._storyAPI.getStoryRecommendedList(
			id,
			() => {},
			() => {},
			(response) => {
				this.storyRecommended = response;
			},
			() => {},
			() => {}
		)
	}


	public ngOnInit(): void {
		this.paramsSubscription = this._activatedRoute.params.subscribe((params) => {
			this.storyId = +params['storyId'];
			this.getBlogDetailsById(this.storyId.toString());
			this._getStoryRecommendedList(this.storyId.toString());
		})

	}

	public initSEO(): void {
		const seoData: SeoData = {
			title: this.storyDetails.title,
			tags: {
				description: {
					charset: 'utf-8',
					name: 'description',
					content: this._addStructuredData.removeHtmlTags(this.storyDetails.description)
				}
			},
			facebook: {
				title: this.storyDetails.title,
				type: 'website',
				description: this._addStructuredData.removeHtmlTags(this.storyDetails.description),
				image: {
					url: this.storyDetails.bannerImageMobile,
					type: 'image/jpeg',
					width: '600',
					height: '600',
					alt: this.storyDetails.title
				},
				url: `https://anuprerna.com${this._router.url}`
			},
			twitter: {
				title: this.storyDetails.title,
				description: this._addStructuredData.removeHtmlTags(this.storyDetails.description),
				cardType: TwitterCardType.SUMMARY_LARGE,
				image: {
					url: this.storyDetails.bannerImageMobile,
					alt: this.storyDetails.title
				}
			}
		};

		this._seo.set(seoData);
	}

	public sortedStoryContentSection(arr: ContentSectionList[]): ContentSectionList[] {
		return arr.sort((n1, n2) => {
			return n1.sortOrder - n2.sortOrder;
		});
	}

	public getBlogDetailsById(id: string): void {
		this._storyAPI.getStoryDetailsById(
			id,
			() => {
				this.isLoading = true;
			},
			(response: StoryDetailsV2) => {
			},
			(response: StoryDetailsV2) => {
				if (response) {
					this.storyDetails = response;
					this.initSEO();
					this._addStructuredData.mapStoryToArticleStructure(this.storyDetails);
					this.storyDetails.storyContentSectionList = this.sortedStoryContentSection(this.storyDetails.storyContentSectionList);
					this.isLoading = false;
				} else {
					if (this._browser.isBrowser()) {
						this._router.navigate(['/']).then(() => {
							this.isLoading = false;
						});
					}
				}
			},
			(error: string) => {
				if (this._browser.isBrowser()) {
					this._router.navigate(['/']).then(() => {
						this.isLoading = false;
					});
				}
			},
			() => {
			},
		);
	}

	public toggleDropdown(): void {
		this.dropdown = !this.dropdown;
	}

	ngOnDestroy(): void {
		this.paramsSubscription.unsubscribe();
	}
}
